import { c as _c } from "react/compiler-runtime";
import { EmailListType } from 'modules/profile/mailing-settings/types/email-list-interface';
import { useEffect, useState } from 'react';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import useSWR from 'swr';
export const useEmailList = isReady => {
  const $ = _c(7);
  const {
    user
  } = useUser();
  const [shouldFetch, setShouldFetch] = useState(false);
  let t0;
  let t1;
  if ($[0] !== isReady) {
    t0 = () => {
      if (isReady) {
        setShouldFetch(true);
      }
    };
    t1 = [isReady];
    $[0] = isReady;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      method: RequestMethodsEnum.get
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    fetcher
  } = useFetch(t2);
  let t3;
  if ($[4] !== shouldFetch || $[5] !== user) {
    t3 = () => user && shouldFetch && "/api/dashboard/customer/mailing/sender-email/full-list";
    $[4] = shouldFetch;
    $[5] = user;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return useSWR(t3, fetcher);
};